var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        [
          _c("v-card-text", [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-center justify-center text-center py-3",
              },
              [
                _c("h2", { staticClass: "mb-5" }, [
                  _vm._v("Información Exógena"),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "v-row",
        {
          staticClass: "mt-3",
          staticStyle: { "margin-left": "1% !important" },
          attrs: { justify: "center" },
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "overflow-visible",
              staticStyle: { height: "56px" },
            },
            [
              _c(
                "v-bottom-navigation",
                {
                  attrs: {
                    elevation: 24,
                    color: "rgb(204 33 40)",
                    width: "98% !important",
                  },
                  model: {
                    value: _vm.selectedTab,
                    callback: function ($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "nav-btn",
                      attrs: { value: "configImport" },
                    },
                    [_vm._v(" Configuración - Importación ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "nav-btn",
                      attrs: { value: "configFormats" },
                    },
                    [_vm._v(" Configuración - Formatos ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "nav-btn",
                      attrs: { value: "generationFormats" },
                    },
                    [_vm._v(" Generación de formatos ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "base-card",
        [
          _c("v-card-text", { staticClass: "mt-3" }, [
            _c(
              "div",
              [
                _c(
                  _vm.currentComponent,
                  _vm._b(
                    { tag: "component" },
                    "component",
                    _vm.componentProps,
                    false
                  )
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }